import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import "simplebar-react/dist/simplebar.min.css";

import AppRouter from "./router/AppRouter";
import CustomScrollableDialog from "./shared/components/ui/CustomScrollableDialog";
import CustomConfirmDialog from "./shared/components/ui/CustomConfirmDialog";
import BackDrop from "./shared/components/ui/BackDrop";
import CustomConfirmDialog2 from "./shared/components/ui/CustomConfirmDialog/CustomConfirmDialog";
import AppTheme from "./theme/AppTheme";
import { Bounce, ToastContainer } from "react-toastify";
// import useInternetConnection from "./shared/hooks/useInternetConnection";
import { queryClient } from "./shared/query-client/query-client";
import InfoModalGenericObject from "./shared/components/ui/ModalGenericObject/InfoModalGenericObject";

function App() {

  //useInternetConnection();

  return (
    <QueryClientProvider client={queryClient}>
      <AppTheme>
        {/* ====== router ====== */}
        <RouterProvider router={AppRouter} />

        {/*Componente para renderizar informacion de un objeto*/}
        <InfoModalGenericObject />

        {/* <SnackBarComponente /> */}
        <BackDrop />
        <CustomConfirmDialog />
        <CustomScrollableDialog />
        <CustomConfirmDialog2 />

        <ToastContainer
          position="top-right"
          autoClose={3000}
          limit={3}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
      </AppTheme>
    </QueryClientProvider>
  );
}

export default App;
